import { KABBAGE_ACCOUNT } from 'axp-product-ducks';
import { getProcedureResult } from 'iguazu-rpc';
import { READ_CUSTOMER_PRODUCTS_V2_FUNCTION, ROUTES } from '../constants';
import redirect from './redirect';

const isBlueprintProduct = (product) => product.type === KABBAGE_ACCOUNT;

const redirectToBlueprint = (store) => (nextState, replace) => {
  const state = store.getState();
  const productsResult = getProcedureResult({
    procedureName: READ_CUSTOMER_PRODUCTS_V2_FUNCTION,
    args: {
      timeout: 6e3,
    },
  })(state);
  const hasBlueprintProduct = productsResult.some(isBlueprintProduct);
  if (hasBlueprintProduct) {
    const blueprintApiUrl = state.getIn(['config', 'blueprintApiUrl']);
    const blueprintUrl = `${blueprintApiUrl}/bounce/login-with-amex`;
    redirect(blueprintUrl, replace);
  } else {
    redirect(ROUTES.HOME, replace);
  }
};

export default redirectToBlueprint;
